// Angular
import { Injectable } from '@angular/core';
// RxJS
import { BehaviorSubject, Observable } from 'rxjs';
// Object path
import * as objectPath from 'object-path';
// Services
import { MenuConfigService } from './menu-config.service';
import { map } from 'rxjs/operators';

@Injectable()
export class MenuAsideService {
	// Public properties
	// menuList$: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
	menuList$: Observable<any[]>;

	/**
	 * Service constructor
	 *
	 * @param menuConfigService: MenuConfigService
	 */
	constructor(private menuConfigService: MenuConfigService) {
		this.loadMenu();
	}

	/**
	 * Load menu list
	 */
	loadMenu() {
		// get menu list
		this.menuList$ = this.menuConfigService.onConfigUpdated$.pipe(
			map(()=>objectPath.get(this.menuConfigService.getMenus(), 'aside.items'))
		)
		// const menuItems: any[] = objectPath.get(this.menuConfigService.getMenus(), 'aside.items');
		// this.menuList$.next(menuItems);
	}
}
